import { Button, FoldPanel, showDialog, showToast, Specimens, Stack } from '@src/components';
import { supportEmail } from '@src/site';

/**
 * The only way to open a dialog. The host lives on App — this section just
 * pushes contents into it, the same way a product screen does.
 */
export function DialogSection() {
  return (
    <FoldPanel
      id="dialogs"
      title="Dialogs"
      hint="One host on App, always above the blurred page. Screens call showDialog() and pass close / cancel / submit — cancel is optional."
      example={`showDialog({
  title: 'Still have troubles?',
  submit: 'Okay',
  children: 'Write to postman@…',
});`}
    >
      <Specimens
        label="Info"
        note="Close + submit. No cancel — an explanation that only needs Okay."
      >
        <Button
          variant="secondary"
          size="small"
          onClick={() =>
            showDialog({
              title: 'Still have troubles?',
              submit: 'Okay',
              testId: 'kit-dialog-info',
              children: `If you used an older account with Telegram and never added an email, write to ${supportEmail()} with a link to the game and the name on the card — or say if you are the organizer of that game.`,
            })
          }
        >
          Open info dialog
        </Button>
      </Specimens>
      <Specimens
        label="Confirm"
        note="Close + cancel + submit. Submit can be danger when the action destroys something."
      >
        <Stack gap={3}>
          <Button
            variant="secondary"
            size="small"
            onClick={() =>
              showDialog({
                title: 'Leave this page?',
                cancel: 'Cancel',
                submit: 'Leave',
                testId: 'kit-dialog-confirm',
                children: 'Unsaved changes will be lost.',
                onSubmit: () => showToast('Left the page'),
              })
            }
          >
            Open confirm dialog
          </Button>
          <Button
            variant="secondary"
            size="small"
            onClick={() =>
              showDialog({
                title: 'Delete this game?',
                cancel: 'Cancel',
                submit: 'Delete',
                submitVariant: 'danger',
                testId: 'kit-dialog-danger',
                children: 'Everyone in the game will lose access. This cannot be undone.',
                onSubmit: () => showToast('Game deleted'),
              })
            }
          >
            Open danger dialog
          </Button>
        </Stack>
      </Specimens>
    </FoldPanel>
  );
}